import { useQuery } from "@tanstack/react-query";

import { fetchTheme } from "@/lib/theme";
import type { Platform } from "@/lib/theme/resolvePlatform";
import type { ThemeConfig } from "@/lib/theme/types";

export const themeQueryKey = (platform?: Platform) =>
  ["theme", platform ?? "default"] as const;

export function useThemeQuery(platform?: Platform) {
  return useQuery<ThemeConfig>({
    queryKey: themeQueryKey(platform),
    queryFn: () => fetchTheme(platform),
    staleTime: 5 * 60 * 1000,
  });
}
